export default function IconQuiet() {
    return (
        <svg width="1245" height="292" viewBox="0 0 1245 292" fill="none" xmlns="http://www.w3.org/2000/svg" className="img-title-svg">
            <g clipPath="url(#clip0_5477_91556)">
                <g clipPath="url(#clip1_5477_91556)">
                    <path d="M815.672 178.614H844.174L881.832 38.0098H853.357L815.672 178.614Z" fill="white" />
                    <path
                        d="M575.146 116.133H537.978L556.917 149.322H491.137C489.774 149.401 488.464 148.784 487.656 147.684C486.847 146.584 486.65 145.149 487.132 143.872L506.206 72.7522C507.122 69.6617 509.882 67.4803 513.1 67.3024H603.022C604.38 67.2334 605.682 67.8537 606.484 68.9522C607.286 70.0508 607.479 71.4795 607 72.7522L595.964 113.953L615.256 147.741C615.447 147.142 615.665 146.542 615.829 145.943L635.993 70.7085C640.843 52.6425 630.107 38.0098 612.068 38.0098H519.858C501.819 38.0098 483.262 52.6425 478.412 70.7085L458.248 145.943C453.425 163.982 464.134 178.642 482.172 178.642H610.924L575.146 116.133Z"
                        fill="white"
                    />
                    <path
                        d="M766.843 150.309H667.93L697.903 38.125H668.611L638.255 151.481C634.222 166.549 643.16 178.73 658.202 178.73H788.424L826.11 38.125H796.817L766.843 150.309Z"
                        fill="white"
                    />
                    <path d="M1244.71 38.0098H1086.91L1079.06 67.2479H1143.72L1113.88 178.614H1142.39L1172.22 67.2479H1236.89L1244.71 38.0098Z" fill="white" />
                    <path d="M871.34 178.621H1028.81L1036.63 149.437H907.663L914.747 122.924H1043.74L1051.56 93.7129H894.093L871.34 178.621Z" fill="white" />
                    <path d="M901.207 67.2207H1058.68L1066.5 38.0098H909.028L901.207 67.2207Z" fill="white" />
                    <path d="M357.154 123.058H435.822L443.643 93.8203H365.002L357.154 123.058Z" fill="white" />
                    <path d="M191.863 0H112.541L181.835 93.7365L232.409 54.9339L191.863 0Z" fill="white" />
                    <path d="M272.708 216.654H352.03L288.458 130.656L233.742 163.927L272.708 216.654Z" fill="white" />
                    <path d="M424.676 0H325.026L152.731 132.185H190.443L0 292L326.252 93.8455H288.104L424.676 0Z" fill="url(#paint0_linear_5477_91556)" />
                </g>
            </g>
            <defs>
                <linearGradient id="paint0_linear_5477_91556" x1="401.187" y1="-1.86434e-06" x2="0.497222" y2="291.522" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
                <clipPath id="clip0_5477_91556">
                    <rect width="1244.71" height="292" fill="white" />
                </clipPath>
                <clipPath id="clip1_5477_91556">
                    <rect width="1244.71" height="292" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
